export default {
    None: 0,
    /// <summary>
    /// Mầm non
    /// </summary>
    Kintergarten: 5,

    /// <summary>
    /// Tiểu học
    /// </summary>
    PrimarySchool: 10,

    /// <summary>
    /// Trung học
    /// </summary>
    SecondarySchool: 15,

    /// <summary>
    /// THPT
    /// </summary>
    HighSchool: 20,

    /// <summary>
    /// Liên cấp 1,2
    /// </summary>
    InterLevelSchool12: 25,

    /// <summary>
    /// Liên cấp 2,3
    /// </summary>
    InterLevelSchool23: 30,

    /// <summary>
    /// Liên cấp 1,2,3
    /// </summary>
    InterLevelSchool123: 35,

    /// <summary>
    /// GDTX
    /// </summary>
    ContinuingEducation: 40,

    /// <summary>
    /// Trung cấp chuyên nghiệp
    /// </summary>
    IntermediateProfessionalSchool: 45,

    /// <summary>
    /// Cao đẳng
    /// </summary>
    College: 50,

    /// <summary>
    /// Đại học
    /// </summary>
    University: 55,

    /// <summary>
    /// Khác
    /// </summary>
    Other: 60,
}